export default {
	branchList: [],
	objBranchEdit: [],
	branchLogo: ''
}
